__turbopack_context__.v({
  "error": "FormInput-module__NneXOa__error",
  "input": "FormInput-module__NneXOa__input",
  "inputError": "FormInput-module__NneXOa__inputError",
  "label": "FormInput-module__NneXOa__label",
});
